import React from 'react'
import { connect } from 'react-redux'

import { RootStateTypeExtra } from '@store/types'

import Container from '@components/container'
import DataHandler from '@components/data-handler'
import InteractiveMapControl from '@components/interactive-map-control'

import {
  selectFromResult as selectFromInteractiveMapResult,
  useGetInteractiveMapQuery,
} from '@api/interactive-map'

import { SessionMap } from '@firebaseUtil/types'

import InteractiveMapSkeleton from './interactive-map-skeleton'

export interface PagePropsInterface {
  session: SessionMap | undefined
  projectName: string
}

function InteractiveMap({ session, projectName }: PagePropsInterface) {
  const interactiveMapPayload = useGetInteractiveMapQuery(
    { projectName },
    { selectFromResult: selectFromInteractiveMapResult }
  )

  return (
    <Container>
      <DataHandler
        payloads={{
          ...interactiveMapPayload,
          data: interactiveMapPayload.interactiveMapData,
        }}
        skeletonFrame={<InteractiveMapSkeleton />}
      >
        <div className="h-full w-full">
          <div className="relative flex h-top-bar w-full items-center justify-center px-5 text-neutralColour">
            <div className="text-title font-medium">Map</div>
          </div>
          <InteractiveMapControl
            interactiveMapList={interactiveMapPayload.interactiveMapData}
            interactiveMapSession={session?.interactiveMap ?? []}
            interactiveMapActiveCategory={session?.interactiveMapActiveCategory}
            storyMode={interactiveMapPayload.storyMode}
          />
        </div>
      </DataHandler>
    </Container>
  )
}

export default connect(
  ({ projectIdentity, firestore: { session } }: RootStateTypeExtra) => ({
    session,
    projectName: projectIdentity.projectId,
  })
)(InteractiveMap)
